import { useMemo, useState } from "react";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import {
  INITIAL_FILTERS,
  MOCK_MARKETING_CONTENTS,
} from "../constants";
import {
  filterMarketingContents,
  getUniqueFieldValues,
  matchesDestaqueTab,
} from "../utils";

export default function useFranchiseMarketing() {
  const snackbar = useSnackbar();

  const [search, setSearch] = useState("");
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [destaqueTab, setDestaqueTab] = useState("BANNER");
  const [previewItem, setPreviewItem] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const categoriasOptions = useMemo(
    () => getUniqueFieldValues(MOCK_MARKETING_CONTENTS, "categoria"),
    [],
  );

  const campanhasOptions = useMemo(
    () => getUniqueFieldValues(MOCK_MARKETING_CONTENTS, "campanha"),
    [],
  );

  const filteredContents = useMemo(
    () => filterMarketingContents(MOCK_MARKETING_CONTENTS, search, filters),
    [search, filters],
  );

  const destaques = useMemo(
    () =>
      filteredContents
        .filter((item) => matchesDestaqueTab(item.tipo, destaqueTab))
        .slice(0, 3),
    [filteredContents, destaqueTab],
  );

  const videos = useMemo(
    () => filteredContents.filter((item) => item.tipo === "VIDEO").slice(0, 4),
    [filteredContents],
  );

  const materiaisRecentes = useMemo(
    () => filteredContents.filter((item) => item.tipo === "MATERIAL_PDF").slice(0, 3),
    [filteredContents],
  );

  const toggleFilterArray = (field, value) => {
    setFilters((prev) => {
      const current = prev[field];
      const next = current.includes(value)
        ? current.filter((item) => item !== value)
        : [...current, value];
      return { ...prev, [field]: next };
    });
  };

  const clearFilters = () => {
    setSearch("");
    setFilters(INITIAL_FILTERS);
  };

  const handleDownload = (item) => {
    snackbar.showMessage(`Download iniciado: ${item.titulo}`, { severity: "success" });
  };

  const handleShare = (item) => {
    snackbar.showMessage(`Link copiado: ${item.titulo}`, { severity: "success" });
  };

  const handleFavorite = (item) => {
    setFavorites((prev) => {
      const isFavorite = prev.includes(item.id);
      snackbar.showMessage(
        isFavorite ? "Removido dos favoritos" : "Adicionado aos favoritos",
        { severity: "info" },
      );
      return isFavorite ? prev.filter((id) => id !== item.id) : [...prev, item.id];
    });
  };

  const handleViewCampaign = (campanhaId) => {
    const campanha = MOCK_MARKETING_CONTENTS.find((item) => item.id === campanhaId);
    if (campanha) setPreviewItem(campanha);
  };

  const cardHandlers = {
    onView: setPreviewItem,
    onDownload: handleDownload,
    onShare: handleShare,
    onFavorite: handleFavorite,
    isFavorite: (id) => favorites.includes(id),
  };

  return {
    search,
    setSearch,
    filtersOpen,
    setFiltersOpen,
    destaqueTab,
    setDestaqueTab,
    previewItem,
    setPreviewItem,
    filters,
    setFilters,
    categoriasOptions,
    campanhasOptions,
    destaques,
    videos,
    materiaisRecentes,
    toggleFilterArray,
    clearFilters,
    handleViewCampaign,
    cardHandlers,
    snackbar,
  };
}
